import { ErrorHandler, Injectable } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: Error) {
    datadogLogs.logger.error(error?.message, error);
  }
}
